import { getCommentsTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { encodeLinkSymbols } from "@/utility/encodeDecodeLinks";

const editCommentsWidgetConfig = (editor, event) => {
  const parsedContent = new DOMParser().parseFromString(event.target.offsetParent.innerHTML, "text/html");
  const commentWidgetData = parsedContent.querySelectorAll('[data-tiny-mce-component="landercomments"]')[0];

  let existData = null;
  if (commentWidgetData) {
    existData = JSON.stringify(commentWidgetData.getAttribute("data-comments-widget-data"));
  }

  editor.windowManager.openUrl({
    title: "Comments Widget",
    url: "/comments-widget-dialog?data=" + existData,
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      editor.windowManager.alert("Success!");
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      const shortcodeDiv = event.target.offsetParent;
      shortcodeDiv
        .querySelectorAll('[data-tiny-mce-component="landercomments"]')[0]
        .setAttribute("data-comments-widget-data", encodeLinkSymbols(message.data));
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

const commentsWidgetConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Comments Widget",
    url: "/comments-widget-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();
      const templateToAdd = getCommentsTemplate(currentData);

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = encodeLinkSymbols(message.data);
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { commentsWidgetConfig, editCommentsWidgetConfig };
